const GoogleAdSquare = () => {
  return (
    <>
      <script
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1405387634139495"
        crossOrigin="anonymous"
        async
      />
      <ins
        className="adsbygoogle"
        style={{display: "block"}}
        data-ad-client="ca-pub-1405387634139495"
        data-ad-slot="7639734569"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
      <script>
        (adsbygoogle = window.adsbygoogle || []).push({});
      </script>
    </>
  );
};

export default GoogleAdSquare;
